import {FascicoloFull} from '../../../../common/models/fascicolo/fascicolo-full';
import {AutoritaGiudiziaria} from '../../../../common/models/tipologiche/autorita-giudiziaria';
import {SedeTerritoriale} from '../../../../common/models/tipologiche/sede-territoriale';
import {QuestionBase} from '../../../../core/components/dynamic-form/models/question-base';


export class FascicoloGenerico extends FascicoloFull {
  sezione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([{
      key: '',
      label: 'Titolo',
      required: true,
      controlType: 'textbox',
      placeholder: 'Inserire titolo',
      size: 'sm-6',
      type: 'text',
      value: ''
    }])
  }
}
